import { combineReducers } from 'redux';
import external from '../External/reducers';
import internal from '../Internal/reducers';
export default combineReducers({
  external,
  internal,
});



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/screens/Preview/reducers/index.js
 **/